import { Notification, NotificationStepStatus, NotificationType } from '@dynamik/common/clients/notification-clients';

export class ProcessVoucherNotificationToVoucherIdValueConverter {
  toView(n: Notification) {
    if (n?.type !== NotificationType.ProcessVouchers || n.steps.some(x => x.status !== NotificationStepStatus.Success)) {
      return undefined;
    }
    try {
      if (!n.data || typeof n.data !== 'string' || n.data === 'undefined') {
        return undefined;
      }
      const data = (JSON.parse(n.data) as any[]) ?? [];
      return data?.[0]?.NewVoucherId;
    } catch (error) {
      return undefined;
    }
  }
}
